import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { LastRechtRootEntryVm } from '../../../core/services/standardrecht-viewmodel.service';

@Pipe({
  name: 'orderByLastRechtRootEntryVm'
})
export class OrderByLastRechtRootEntryVmPipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array: Array<LastRechtRootEntryVm>, ascending = true): LastRechtRootEntryVm[] {
    if (!array) {
      return;
    }
    if (ascending) {
      return Array.from(array).sort((item1: LastRechtRootEntryVm, item2: LastRechtRootEntryVm) => {
        return this.comperatorService.lastRechtRootEntryVmComparator(item1, item2);
      });
    } else {
      return Array.from(array).sort((item1: LastRechtRootEntryVm, item2: LastRechtRootEntryVm) => {
        return this.comperatorService.lastRechtRootEntryVmComparator(item2, item1);
      });
    }
  }
}
